<template>
    <v-list-tile>
        <v-dialog persistent :max-width="Modal.Processamento.larguraMaxima" v-model="mostrarDialogoAnular">
            <v-list-tile-title slot="activator">
                <i class="fas fa-exclamation-circle mr-2" aria-hidden="true"/>
                Anular
            </v-list-tile-title>

            <modal-alterar-situacao-lote-e-item v-model="lista" :title="'Anular'"
                                                @salvarAlteracaoSituacao="tratarEventoAnular"
                                                @fecharModalAlteracao="tratarEventoFecharModal"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {actionTypes, Modal} from '@/core/constants'
import ModalAlterarSituacaoLoteEItem from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalAlterarSituacaoLoteEItem'

export default {
    name: 'AcoesAnular',
    components: {ModalAlterarSituacaoLoteEItem},
    props: {
        compraDiretaId: {
            required: true
        }
    },
    data() {
        return {
            mostrarDialogoAnular: false,
            lista: {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            },
            Modal
        }
    },
    watch: {
        'mostrarDialogoAnular': {
            async handler(novoValor) {
                if (novoValor) {
                    try {
                        await this.buscarResumoItensLotes()
                    } catch (e) {
                        this.mostrarNotificacaoErro(e.message)
                    }
                }
            }
        }
    },
    methods: {
        async buscarResumoItensLotes() {
            this.lista = await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_ITEM_E_LOTE, this.compraDiretaId)
        },
        async tratarEventoAnular(objModal) {
            const objParaAnular = {
                compraDiretaId: this.compraDiretaId,
                dados: {
                    itens: objModal.itens,
                    lotes: objModal.lotes,
                    motivo: objModal.motivo,
                    situacao: 'ANULADO'
                }
            }
            await this.$store.dispatch(actionTypes.ALTERAR_SITUACAO_DE_ITEM_E_LOTE, objParaAnular)
            this.mostrarNotificacaoSucesso('Item anulado com sucesso.')
            this.tratarEventoFecharModal()
        },
        tratarEventoFecharModal() {
            this.lista = {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            }
            this.mostrarDialogoAnular = false
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
